import * as React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import { Button } from "src/library/components/Button";
import { Select } from "src/library/components/Forms";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { useProductsApi } from "src/core/products/api/products.api";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";

import { ProductExportParams } from "../api/products.api";

type ProductExportModalProps = Pick<BasicModalProps, "onDismiss" | "open">;

export const ProductExportModal: React.ReactFCWithChildren<ProductExportModalProps> = ({ onDismiss, open }) => {
  const [ exportProductsResponse, exportProducts ] = useProductsApi("EXPORT_PRODUCTS");
  const [ productExportFilters, setProductExportFilters ] = React.useState<ProductExportParams["filters"]>({});

  // handle the response and open the file to trigger the download
  React.useEffect(() => {
    if (exportProductsResponse.data) {
      toast.success(exportProductsResponse.data?.message);
      exportProductsResponse.data = null;
      onDismiss();
    }
  }, [ exportProductsResponse, onDismiss ]);

  return (
    <StyledBasicModal
      title="Export Products"
      open={open}
      onDismiss={() => onDismiss()}
    >
      {exportProductsResponse.error && (
        <ErrorNotice
          message={exportProductsResponse.error.message}
          type="error"
        />
      )}

      {exportProductsResponse.pending ? (
        <LoadingSpinner type="circular" />
      ) : (
        <>
          <Select
            className="select-box"
            as="select"
            label="Published"
            name="product-published"
            handleChange={e => {
              const existingFilters = productExportFilters;

              if (e.target.value === "true") {
                existingFilters.published = true;
              } else if (e.target.value === "false") {
                existingFilters.published = false;
              } else if (typeof existingFilters.published === "boolean") {
                delete existingFilters.published;
              }

              setProductExportFilters(existingFilters);
            }}
            options={[
              {
                text: "Published",
                value: "true"
              },
              {
                text: "Unpublished",
                value: "false"
              }
            ]}
            unselectedOption={{
              text: "Please Select (optional)",
              value: ""
            }}
          />

          <Button
            className="submit-button"
            onClick={() => {
              exportProducts({ filters: productExportFilters });
            }}
          >
            Export Products
          </Button>
        </>
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  .select-box {
    margin-bottom: ${({ theme }) => theme.spacing.margins.md};
  }

  .submit-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;
